/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018 --> 2026 by AsterionDB Inc.                            *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *  Be sure to access the web-app using localhost:3000                        *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { FormGroup, Label, Col, Row, Input, FormFeedback, Button } from 'reactstrap'

import ConfirmationModal from '../widgets/ConfirmationModal'

import { css } from '@emotion/react';
import { RingLoader } from 'react-spinners'

import {AppContext} from '../AppContext';

class GmailConfig extends React.Component
{  
  componentDidMount()
  {
    this.fetchEmailConfig();

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('error')) this.context.postNotification('error', 'Authorization by Google for outbound email has failed: ' + urlParams.get('error'));
    if (urlParams.has('success')) this.context.postNotification('success', 'Outbound email support authorized by Google.');
  }

  confirmEnableDisableSmtp(event)
  {
    this.setState({confirmationModalIsOpen: true, buttonDisabled: true});
  }

  constructor(props)
  {
    super();

    this.state =
    {
      modalIsOpen: false,
      smtpEmailSender: '',
      smtpEmailSenderValid: true,
      smtpEmailSenderFB: '',
      updateDisabled: true,
      smtpEnabled: 'N',
      sendTestEmailDisabled: true,
      confirmationModalIsOpen: false,
      gmailClientId: '',
      gmailClientSecret: '',
      redirectUri: '',
      debugSmtp: false,
      spinnerIsSpinning: false,
      buttonDisabled: false
    }

    this.sendTestEmail = this.sendTestEmail.bind(this);
    this.enableDisableSmtp = this.enableDisableSmtp.bind(this);
    this.setEmailAddress = this.setEmailAddress.bind(this);
    this.updateEmailConfig = this.updateEmailConfig.bind(this);
    this.fetchEmailConfig = this.fetchEmailConfig.bind(this);
    this.setGmailClientId = this.setGmailClientId.bind(this);
    this.setGmailClientSecret = this.setGmailClientSecret.bind(this);
    this.setRedirectUri = this.setRedirectUri.bind(this);
    this.confirmEnableDisableSmtp = this.confirmEnableDisableSmtp.bind(this);
    this.toggleDebugSmtp = this.toggleDebugSmtp.bind(this);
  }

  async enableDisableSmtp(confirmed)
  {
    this.setState({confirmationModalIsOpen: false, buttonDisabled: false});
    if (!confirmed) return;

    if ('' === this.state.smtpEmailSender)
    {
      this.context.postNotification('error', 'You have to specify an email address.');
      return;
    }

    let bodyData = {};
    bodyData.origin = window.location.origin;

    if ('Y' === this.state.smtpEnabled)
    {
      let result = await this.context.dbTwig.callRestAPI('email', 'disableSmtp', bodyData);
      if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Unable to disable SMTP support');
      this.setState({smtpEnabled: 'N', sendTestEmailDisabled: true});
      this.props.fetchWebsiteProfile(true);
    }
    else
    {
      let result = await this.context.dbTwig.callRestAPI('email', 'getGmailSigninUrl', bodyData);
      if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Unable to redirect to Gmail to enable SMTP support');
      this.setState({spinnerIsSpinning: true});
      window.location.href = result.jsonData.gmailSigninUrl;
    }
  }

  async fetchEmailConfig()
  {
    let result = await this.context.dbTwig.callRestAPI('email', 'getEmailConfig');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error getting email configuration');

    this.setState(
    {
      smtpEmailSender: (null === result.jsonData.smtpEmailSender ? '' : result.jsonData.smtpEmailSender),
      smtpEmailSenderValid: true,
      gmailClientId: (null === result.jsonData.gmailClientId ? '' : result.jsonData.gmailClientId),
      gmailClientSecret: (null === result.jsonData.gmailClientSecret ? '' : result.jsonData.gmailClientSecret),
      redirectUri: result.jsonData.redirectUri,
      debugSmtp: result.jsonData.debugSmtp === 'Y' ? true : false,
      smtpEnabled: result.jsonData.smtpEnabled,
      updateDisabled: true,
      sendTestEmailDisabled: 'Y' === result.jsonData.smtpEnabled ? false : true
    });
  }

  render()
  {
    if (this.props.tabId !== this.props.tabIndex) return false;

    var enabledText;
    var buttonText;
    var buttonHelp = null;
    var confirmationModalText = 'Are you sure you want to enable SMTP support?  Doing so will require that you log-in to Google.  Press OK to be redirected to the Google sign-in page.';

    const spinnerCss = css`
      display: block;
      margin: 0 auto;
      border-color: red;
    `;

//    if ('Y' === this.state.smtpEnabled && '' !== this.state.gmailClientSecret && '' !== this.state.gmailClientId)
    if ('Y' === this.state.smtpEnabled)
    {
      enabledText = 'Outbound email support is enabled';
      buttonText = 'Disable';
      confirmationModalText = 'Are you sure you want to disable SMTP support?';
      buttonHelp = 'Press this button to disable outbound email support';
    }
    else
    {
      enabledText = 'Outbound email support is disabled';
      buttonText = 'Enable';
      if ('' === this.state.smtpEmailSender || '' === this.state.gmailClientSecret || '' === this.state.gmailClientId) 
        buttonHelp = 'You have to specify a value for the outbound email address, Gmail Client Id and Secret.';
      else
        buttonHelp = 'Press this button to enable outbound email support.'
    }

    return(
      <div>
        <Row style={{paddingTop: "10px"}}>
          <Col><h3>Google Email Configuration</h3></Col>
        </Row>
        <FormGroup row>
          <Label for='smtpEmailSender' sm="2">Outbound SMTP Email Account</Label>
          <Col sm="2">
            <Input type="text" id="smtpEmailSender" placeholder="(e.g. administrator@yourcompany.com)"
              invalid={(undefined === this.state.smtpEmailSenderValid ? undefined : !this.state.smtpEmailSenderValid)} 
              valid={(undefined === this.state.smtpEmailSenderValid ? undefined : this.state.smtpEmailSenderValid)} 
              value={this.state.smtpEmailSender} onChange={this.setEmailAddress}/>
            <FormFeedback valid={false}>{this.state.smtpEmailSenderFB}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for='redirectUri' sm='2'>Redirect URI</Label>
          <Col sm='2'>
            <Input type='text' id='redirectUri' value={this.state.redirectUri} onChange={this.setRedirectUri}></Input>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for='gmailClientId' sm='2'>Gmail Client ID</Label>
          <Col sm='4'>
            <Input type='text' id='gmailClientId' value={this.state.gmailClientId} onChange={this.setGmailClientId}></Input>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for='gmailClientSecret' sm='2'>Gmail Client Secret</Label>
          <Col sm='2'>
            <Input type='text' id='gmailClientSecret' value={this.state.gmailClientSecret} onChange={this.setGmailClientSecret}></Input>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for='debugSmtp' sm='2'>Debug SMTP?</Label>
          <Col sm='1' style={{paddingTop: "10px"}} >
            <Input id='debugSmtp' onChange={this.toggleDebugSmtp} 
              checked={this.state.debugSmtp ? "checked" : ''} type="checkbox"/>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col sm="2">
            <Button color="primary" onClick={this.updateEmailConfig} disabled={this.state.updateDisabled}>Update</Button>
          </Col>
          <Col>
            <Button color="secondary" onClick={this.fetchEmailConfig}>Reset</Button>
          </Col>
        </FormGroup>
        <FormGroup row style={{paddingTop: "10px"}}>
          <Col sm="2">{enabledText}</Col>
          <Col sm="1"><Button title={buttonHelp} color="primary" disabled={this.state.buttonDisabled} onClick={this.confirmEnableDisableSmtp}>{buttonText}</Button></Col>
        {( 'Y' === this.state.smtpEnabled &&
          <Col>
            <Button color="primary" onClick={this.sendTestEmail} disabled={this.state.sendTestEmailDisabled}>Send Test Email</Button>
          </Col>
        )}
        </FormGroup>
        <ConfirmationModal modalIsOpen={this.state.confirmationModalIsOpen} closeModal={this.enableDisableSmtp}
          modalText={confirmationModalText}
        />
        <div style={{position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}>
          <RingLoader css={spinnerCss} size={75} color={'#4A90E2'} loading={this.state.spinnerIsSpinning}/>          
        </div>
      </div>
    );
  }

  async sendTestEmail(event)
  {
    this.setState({sendTestEmailDisabled: true, spinnerIsSpinning: true});

    event.preventDefault();

    var bodyData = {};
    bodyData.subject = 'AsterionDB: Testing outbound SMTP connection.';
    bodyData.emailBody = 'The test was successful.';

    let result = await this.context.dbTwig.callRestAPI('email', 'sendTestEmail', bodyData);
    this.setState({sendTestEmailDisabled: false, spinnerIsSpinning: false});
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error sending test email');
    this.context.postNotification('info', 'Test email sent.');
  }

  setEmailAddress(event)
  {
    let emailAddressFB = null;
    let valid = true;

    if ('' !== event.target.value && !window.isEmailAddressValid(event.target.value))
    {
      valid = false;
      emailAddressFB = 'That does not look like a valid email address.';
    }

    if (valid && 'Y' === this.state.smtpEnabled)
      this.context.postNotification('info', 'Note - If you change the outbound email address you will have to re-authorize access with Google.');
    
    this.setState(
    {
      smtpEmailSender: event.target.value,
      smtpEmailSenderValid: valid,
      smtpEmailSenderFB: emailAddressFB,
      updateDisabled: !valid
    });
  }

  setGmailClientId(event)
  {
    this.setState(
    {
      gmailClientId: event.target.value, 
      smtpEnabled: 'N',
      updateDisabled: false
    });
  }

  setGmailClientSecret(event)
  {
    this.setState(
    {
      gmailClientSecret: event.target.value, 
      smtpEnabled: 'N',
      updateDisabled: false
    });
  }

  setRedirectUri(event)
  {
    this.setState(
    {
      redirectUri: event.target.value, 
      smtpEnabled: 'N',
      updateDisabled: false
    });
  }

  toggleDebugSmtp()
  {
    let debugSmtp = !this.state.debugSmtp; 
    this.setState({updateDisabled: false, debugSmtp});
  }

  async updateEmailConfig(event)
  {
    event.preventDefault();

    this.setState({updateDisabled: true});

    let bodyData = {};
    bodyData.smtpEmailSender = this.state.smtpEmailSender;
    bodyData.gmailClientId = this.state.gmailClientId;
    bodyData.gmailClientSecret = this.state.gmailClientSecret;
    bodyData.redirectUri = this.state.redirectUri;
    bodyData.debugSmtp = this.state.debugSmtp ? 'Y' : 'N';
    
    let result = await this.context.dbTwig.callRestAPI('email', 'updateEmailConfig', bodyData);
    if ('success' !== result.status)
    {
      this.setState({updateDisabled: false});
      return this.context.dbTwig.apiErrorHandler(result, 'Error updating email configuration');
    } 

    this.context.postNotification('info', 'Email configuration updated.');
//    this.setState({smtpEnabled: '' === this.state.smtpEmailSender ? true : false})
    this.props.fetchWebsiteProfile(true);        
  }  
}

GmailConfig.contextType = AppContext;

export default GmailConfig;